module.exports = __webpack_public_path__ + "static/media/18.bcb324d7.svg";